import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useUpdateRestrictMutation } from "../../redux/userApi";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

function RestrictUser({ show, onHide, user }) {
    const { t } = useTranslation();
    const [updateRestrict] = useUpdateRestrictMutation();

    const handleRestrictConfirm = async () => {
        if (!user) return;
        try {
            const response = await updateRestrict({ user_id: user.id });
            if (response.data && response.data.status) {
                toast.success(response.data.message || t('user_restricted_successfully') || "User restricted successfully.");
            } else {
                toast.error(response.error?.data?.message || response.data?.message || t('user_restrict_failed') || "Failed to restrict user.");
            }
        } catch (error) {
            toast.error(t('user_restrict_error') || "An error occurred.");
        }
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('confirm_action')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {t('confirm_restrict_user') || 'Are you sure you want to restrict this user?'}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('cancel')}
                </Button>
                <Button variant="warning" onClick={handleRestrictConfirm}>
                    {t('confirm')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default RestrictUser;
